import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { useAuth } from "@/context/AuthContext";

const TYPE_LABEL = { recharge_mensuelle: "Recharge mensuelle", achat: "Achat de crédits", depense: "Dépense", remboursement: "Remboursement" };

export default function Credits() {
  const navigate = useNavigate();
  const { isAuthed, user } = useAuth();
  const [info, setInfo] = useState(null);

  useEffect(() => {
    if (isAuthed) api.get("/credits/me").then(({ data }) => setInfo(data)).catch(() => {});
  }, [isAuthed]);

  if (user === null) return <div className="center-page" role="status"><p className="eyebrow">Chargement...</p></div>;
  if (!isAuthed) { navigate("/compte"); return null; }

  const txs = (info?.transactions || []).filter((t) => t.type !== "depense");
  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="container page-content fade-in">
        <p className="eyebrow">TES CRÉDITS</p>
        <h1>{info?.credits_balance ?? 0} <em>crédits</em></h1>
        {info?.renewal_date && <p className="muted mt-4">Prochain rechargement le {new Date(info.renewal_date).toLocaleDateString("fr-FR")} ({info.credits_monthly} crédits).</p>}
        <button onClick={() => navigate("/tarifs")} className="btn-primary mt-8">Recharger / changer de formule <span aria-hidden="true">→</span></button>

        <div className="rule mt-14 pt-10">
          <p className="field-label">Historique</p>
          <div className="mt-6" data-testid="credits-history">
            {txs.length === 0 && <p className="muted text-sm">Aucune opération pour le moment.</p>}
            {txs.map((t) => (
              <div key={t.id} className="cost-row">
                <div><span className="block">{t.action}</span><span className="mono muted text-[10px]">{TYPE_LABEL[t.type] || t.type} · {new Date(t.created_at).toLocaleDateString("fr-FR")}</span></div>
                <span className={`mono ${t.montant >= 0 ? "accent" : ""}`}>{t.montant >= 0 ? "+" : ""}{t.montant}</span>
              </div>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
